import { Button } from '@/components/ui/button';
import { Loader2, SendIcon } from 'lucide-react';
import { useListAppointmentFormSubmissions } from '../api/list-appointment-form-submissions';
import { useSendAppointmentForms } from '../api/send-appointment-forms';
import { AppointmentFormStatus } from './appointment-form-status';

/** Live consent state and a retry for required forms on this booking. */
export function AppointmentFormsPanel({
  appointmentId,
}: { appointmentId: string }) {
  const { submissions, isLoading, isError } =
    useListAppointmentFormSubmissions(appointmentId);
  const { sendForms, isSending } = useSendAppointmentForms(appointmentId);
  const allCompleted =
    submissions.length > 0 &&
    submissions.every((row) => row.status === 'completed');
  const isResend = submissions.some(
    (row) => row.status === 'pending' && row.sentAt
  );
  return (
    <section className="space-y-3" aria-label="Consent forms">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-sm font-semibold">Consent forms</h2>
        {!allCompleted && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="min-h-11"
            disabled={isSending || isLoading || isError}
            onClick={() => sendForms()}
          >
            {isSending ? (
              <Loader2 className="size-4 animate-spin" aria-hidden />
            ) : (
              <SendIcon className="size-4" aria-hidden />
            )}
            {isSending
              ? isResend
                ? 'Resending…'
                : 'Sending…'
              : isResend
                ? 'Resend forms'
                : 'Send forms'}
          </Button>
        )}
      </div>
      <AppointmentFormStatus appointmentId={appointmentId} />
      {!allCompleted && !isError && (
        <p className="text-xs text-muted-foreground">
          {isResend
            ? "Resend outstanding forms to the client's saved email address."
            : "Email the required forms to the client's saved address."}{' '}
          Signed forms will not be sent again.
        </p>
      )}
    </section>
  );
}
